import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { faCog } from '@fortawesome/pro-light-svg-icons/faCog'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext } from 'react'
import { Application, GlobalNavContext } from '../../../GlobalNav'
import { PopupType } from '../../../PopupContext'
import { Dropdown } from '../../Dropdown'
import styles from './AppsDropdown.scss'
// Custom icon for the apps button, courtesy of our design team
const icon: IconDefinition = {
  prefix: 'fal',
  iconName: 'apps',
  icon: [
    20,
    20,
    [],
    '',
    // tslint:disable-next-line
    'M2.16666667,1 C1.52233446,1 1,1.52233446 1,2.16666667 L1,6.16666666 C1,6.81099887 1.52233446,7.33333333 2.16666667,7.33333333 L6.16666666,7.33333333 C6.81099887,7.33333333 7.33333333,6.81099887 7.33333333,6.16666666 L7.33333333,2.16666667 C7.33333333,1.52233446 6.81099887,1 6.16666666,1 L2.16666667,1 Z M2.16666667,0 L6.16666666,0 C7.36328362,-2.1649349e-16 8.33333333,0.97004971 8.33333333,2.16666667 L8.33333333,6.16666666 C8.33333333,7.36328362 7.36328362,8.33333333 6.16666666,8.33333333 L2.16666667,8.33333333 C0.97004971,8.33333333 1.44328993e-16,7.36328362 0,6.16666666 L0,2.16666667 C-1.44328993e-16,0.97004971 0.97004971,2.88657986e-16 2.16666667,0 Z M13.8333334,1 C13.1890012,1 12.6666667,1.52233446 12.6666667,2.16666667 L12.6666667,6.16666666 C12.6666667,6.81099887 13.1890012,7.33333333 13.8333334,7.33333333 L17.8333334,7.33333333 C18.4776656,7.33333333 19,6.81099887 19,6.16666666 L19,2.16666667 C19,1.52233446 18.4776656,1 17.8333334,1 L13.8333334,1 Z M13.8333334,0 L17.8333334,0 C19.0299503,-2.1649349e-16 20,0.97004971 20,2.16666667 L20,6.16666666 C20,7.36328362 19.0299503,8.33333333 17.8333334,8.33333333 L13.8333334,8.33333333 C12.6367164,8.33333333 11.6666667,7.36328362 11.6666667,6.16666666 L11.6666667,2.16666667 C11.6666667,0.97004971 12.6367164,2.88657986e-16 13.8333334,0 Z M2.16666667,12.6666667 C1.52233446,12.6666667 1,13.1890012 1,13.8333334 L1,17.8333334 C1,18.4776656 1.52233446,19 2.16666667,19 L6.16666666,19 C6.81099887,19 7.33333333,18.4776656 7.33333333,17.8333334 L7.33333333,13.8333334 C7.33333333,13.1890012 6.81099887,12.6666667 6.16666666,12.6666667 L2.16666667,12.6666667 Z M2.16666667,11.6666667 L6.16666666,11.6666667 C7.36328362,11.6666667 8.33333333,12.6367164 8.33333333,13.8333334 L8.33333333,17.8333334 C8.33333333,19.0299503 7.36328362,20 6.16666666,20 L2.16666667,20 C0.97004971,20 1.44328993e-16,19.0299503 0,17.8333334 L0,13.8333334 C-1.44328993e-16,12.6367164 0.97004971,11.6666667 2.16666667,11.6666667 Z M13.8333334,12.6666667 C13.1890012,12.6666667 12.6666667,13.1890012 12.6666667,13.8333334 L12.6666667,17.8333334 C12.6666667,18.4776656 13.1890012,19 13.8333334,19 L17.8333334,19 C18.4776656,19 19,18.4776656 19,17.8333334 L19,13.8333334 C19,13.1890012 18.4776656,12.6666667 17.8333334,12.6666667 L13.8333334,12.6666667 Z M13.8333334,11.6666667 L17.8333334,11.6666667 C19.0299503,11.6666667 20,12.6367164 20,13.8333334 L20,17.8333334 C20,19.0299503 19.0299503,20 17.8333334,20 L13.8333334,20 C12.6367164,20 11.6666667,19.0299503 11.6666667,17.8333334 L11.6666667,13.8333334 C11.6666667,12.6367164 12.6367164,11.6666667 13.8333334,11.6666667 Z'
  ]} as unknown as IconDefinition

const iconSelected: IconDefinition = {
  prefix: 'fal',
  iconName: 'appsHover',
  icon: [
    20,
    20,
    [],
    '',
    // tslint:disable-next-line
    'M2.16666667,0 L6.16666666,0 C7.36328362,-2.1649349e-16 8.33333333,0.97004971 8.33333333,2.16666667 L8.33333333,6.16666666 C8.33333333,7.36328362 7.36328362,8.33333333 6.16666666,8.33333333 L2.16666667,8.33333333 C0.97004971,8.33333333 1.44328993e-16,7.36328362 0,6.16666666 L0,2.16666667 C-1.44328993e-16,0.97004971 0.97004971,2.88657986e-16 2.16666667,0 Z M13.8333334,0 L17.8333334,0 C19.0299503,-2.1649349e-16 20,0.97004971 20,2.16666667 L20,6.16666666 C20,7.36328362 19.0299503,8.33333333 17.8333334,8.33333333 L13.8333334,8.33333333 C12.6367164,8.33333333 11.6666667,7.36328362 11.6666667,6.16666666 L11.6666667,2.16666667 C11.6666667,0.97004971 12.6367164,2.88657986e-16 13.8333334,0 Z M2.16666667,11.6666667 L6.16666666,11.6666667 C7.36328362,11.6666667 8.33333333,12.6367164 8.33333333,13.8333334 L8.33333333,17.8333334 C8.33333333,19.0299503 7.36328362,20 6.16666666,20 L2.16666667,20 C0.97004971,20 1.44328993e-16,19.0299503 0,17.8333334 L0,13.8333334 C-1.44328993e-16,12.6367164 0.97004971,11.6666667 2.16666667,11.6666667 Z M13.8333334,11.6666667 L17.8333334,11.6666667 C19.0299503,11.6666667 20,12.6367164 20,13.8333334 L20,17.8333334 C20,19.0299503 19.0299503,20 17.8333334,20 L13.8333334,20 C12.6367164,20 11.6666667,19.0299503 11.6666667,17.8333334 L11.6666667,13.8333334 C11.6666667,12.6367164 12.6367164,11.6666667 13.8333334,11.6666667 Z'
  ]} as unknown as IconDefinition

const AppsDropdownContent = ({ currentApp }) => {
  const navContext = useContext(GlobalNavContext)
  const account = navContext.account

  const hrefGlobalSettingsId = account && account.organization ? account.organization.id : account && account.id
  return (
    <div data-cy="appDrop">
      <div style={{ width: '244px' }}>
        {apps
          .map(({ id, description, internalName }, key) =>
            <Row key={key} href={`/ads/manager/accounts/${account ? account.id : ''}/campaigns`}>
              <Selected selected={currentApp === internalName} />
              <Column>
                <AppTitle key={id} >
                  Quantcast for Marketers
                </AppTitle>
                <AppDescription description={description} />
              </Column>
            </Row>
          )
        }
        <Divisor />
        <Row href={`/org/manager/${hrefGlobalSettingsId}${account && account.organization ? '' : '/accounts'}`}>
          <Selected selected={currentApp === settings.internalName} />
          <Column>
            <AppTitle>
              <FontAwesomeIcon
                icon={faCog}
                size={'1x'}
                color={'black'}
              />
              {settings.displayName}
            </AppTitle>
            <AppDescription description={settings.description} />
          </Column>
        </Row>
      </div>
    </div >
  )
}

const apps = [{
  id: 0,
  internalName: 'QPixel',
  description: 'Reach customers with AI-driven audience insights, targeting, and measurement solutions'
}]

const settings = {
  id: 1,
  displayName: 'Global Settings',
  internalName: 'GlobalSettings',
  description: 'Manage your organization’s settings, users, and supply'
}

const Row = ({ href, children }: any) => (
  <a
    className={styles.app_row}
    data-cy="appsRow"
    href={href}
  >
    {children}
  </a>
)

const Column = ({ children }) => <div style={{ display: 'flex', flexDirection: 'column' }}>{children}</div>

const Selected = ({ selected }) => (
  <div
    style={{
      borderLeftWidth: '5px',
      borderColor: selected ? '#5EB1D9' : '#FFFFFF',
      borderLeftStyle: 'solid',
      height: selected ? '70px' : '',
      left: '-1px',
      position: 'absolute',
    }}
  />
)

const AppDescription = ({ description }) => (
  <div className={styles.app_description}>
    {description}
  </div >
)

const Divisor = () => (
  <div
    style={{
      borderColor: '#E8E8E8',
      borderBottomStyle: 'solid',
      borderWidth: '1px',
      width: '100%',
    }}
  />
)


const AppTitle = ({ children }) => (
  <div className={styles.app_title}>
    {children}
  </div>
)

const AppsDropdown = ({ className = '', currentApp }: { className?: string, currentApp: Application }) => {
  return (
    <Dropdown
      width={244}
      icon={icon}
      iconHover={iconSelected}
      data-cy="appDropdown"
      type={PopupType.APPS}
    >
      <AppsDropdownContent currentApp={currentApp} />
    </Dropdown>
  )
}

export default AppsDropdown
